<section
  class="comments"
  id="comments"
  #referenceComments
  (cdkObserveContent)="contentChanged($event)"
></section>
<mat-tab-group
  #commentsTabGroup
  [(selectedIndex)]="selectedTabIndex"
  (selectedTabChange)="onTabChange($event)"
>
  <mat-tab
    *ngFor="let tab of threadTabs; trackBy: tabTrackByFn; index as i"
    [label]="tab.label | translate"
    [disabled]="tab.disabled"
  >
    <ng-template mat-tab-label>
      <mat-icon *ngIf="tab.icon">{{ tab.icon }}</mat-icon>
      <span
        *ngIf="tab.label"
        acaTabsHoverAnimation
        [tabGroup]="commentsTabGroup"
        [tabIndex]="i"
        [id]="i"
        >{{ tab.label | translate }}</span
      >
    </ng-template>
  </mat-tab>
</mat-tab-group>
<div class="tab-content">
  <div
    class="content trackchanges"
    (cdkObserveContent)="contentChanged($event)"
    [class.hidden]="selectedTabIndex !== 0"
  >
    <div class="commentsCleanupButton">
      <ng-container *ngFor="let child of actions">
        <button
          type="button"
          class="{{ child.class | translate }}"
          title="{{ child.title | translate }}"
          [attr.aria-label]="child.title | translate"
          (click)="acceptDiscardSuggestions(child.title)"
        >
          <span data-automation-id="menu-item-title">{{
            child.title | translate
          }}</span>
        </button>
      </ng-container>
    </div>
    <h1 class="comments__label">
      {{ trackChangesTabLabel | translate }}
    </h1>

    <div
      class="ck ck-sidebar ck-reset ck-sidebar--wide"
      #trackchanges
      (click)="clickSectionComment()"
      (keyup)="clickSectionComment()"
    ></div>
  </div>
</div>
<div class="tab-content">
  <div
    class="content editorial"
    (cdkObserveContent)="contentChanged($event)"
    [class.hidden]="selectedTabIndex !== 1"
  >
    <div class="commentsCleanupButton">
      <button
        type="button"
        id="clean-up-comments"
        class="clean-up-comments"
        title="{{ 'CLEAN_UP_COMMENTS.HEADING' | translate }}"
        [attr.aria-label]="'CLEAN_UP_COMMENTS.HEADING' | translate"
        (click)="cleanUpComments()"
        (keyup.enter)="cleanUpComments()"
      >
        {{ 'CLEAN_UP_COMMENTS.HEADING' | translate }}
      </button>
    </div>
    <h1 class="comments__label">
      {{ commentsTabLabel | translate }}
    </h1>
    <div
      class="ck ck-sidebar ck-reset ck-sidebar--wide box-comments"
      #comments
      (click)="clickSectionComment()"
      (keyup)="clickSectionComment()"
    ></div>
  </div>
</div>
<div class="tab-content">
  <div
    class="content updatemanagercomments"
    (cdkObserveContent)="contentChanged($event)"
    [class.hidden]="selectedTabIndex !== 2"
    *ngIf="(featureFlags$ | async)[GENAI_UPDATE_MANAGER_COMMENTS]"
  >
    <div
      class="commentsCleanupButton"
      *ngIf="(aiUMCReleaseNotes$ | async)?.length"
    >
      <button
        class="clean-up-comments"
        title="{{ 'APP.COMMENTS.DELETE_UMC_COMMENT.CLEAR_ALL' | translate }}"
        (click)="clearAllUMCComments()"
        (keyup.enter)="clearAllUMCComments()"
      >
        {{ 'APP.COMMENTS.DELETE_UMC_COMMENT.CLEAR_ALL' | translate }}
      </button>
    </div>
    <h1 class="comments__label">
      {{ 'APP.COMMENTS.UPDATE_MANAGER_COMMENTS' | translate }}
    </h1>
    <div class="loading-container" *ngIf="umcReleaseNotesLoading$ | async">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
    <div
      class="ck ck-sidebar ck-reset ck-sidebar--wide box-comments"
      #updatemanagercomments
      (click)="clickSectionComment()"
      (keyup)="clickSectionComment($event)"
    >
      <mat-list>
        <mat-list-item
          class="ai-umc-comment-item"
          *ngFor="let option of aiUMCReleaseNotes$ | async"
        >
          <mat-checkbox
            [value]="option.id"
            [checked]="isAIUMCNoteSelected(option.id)"
            (change)="onSelectionChange(option.id)"
          >
            <div class="comment-border">
              <span class="circle-icon">AI</span>
              <div>
                <span class="comment-section">{{
                  option.section | umcSentenceCase
                }}</span>
                <mat-icon class="action-icon">
                  {{ option.type === 'added' ? 'add' : 'remove' }}
                </mat-icon>
                <span
                  class="ai-umc-comment-span"
                  matTooltip="{{ option.summary | umcSentenceCase }}"
                  matTooltipPosition="below"
                  matTooltipClass="ai-umc-tooltip"
                >
                  {{ option.summary | umcSentenceCase }}
                </span>
              </div>
              <button
                type="button"
                class="wk-button wk-button-icon umc-comment-clear-btn"
                (click)="onDeleteUMCComment($event, option)"
                title="{{
                  'APP.COMMENTS.DELETE_UMC_COMMENT.CLEAR' | translate
                }}"
              >
                <span class="wk-icon-trash" aria-hidden="true"></span>
              </button>
            </div>
          </mat-checkbox>
        </mat-list-item>
      </mat-list>
    </div>
  </div>
  <div
    class="content releasenotes"
    (cdkObserveContent)="contentChanged($event)"
    [class.hidden]="selectedTabIndex !== 2"
  >
    <h1 class="comments__label">
      {{ releaseNotesTabLabel | translate }}
    </h1>
    <div
      class="ck ck-sidebar ck-reset ck-sidebar--wide box-comments"
      #releasenotes
      (click)="clickSectionComment()"
      (keyup)="clickSectionComment($event)"
    ></div>
  </div>
</div>
<button
  class="scroll-to-top-btn"
  *ngIf="
    showScrollTop &&
    selectedTabIndex === 2 &&
    (aiUMCReleaseNotes$ | async)?.length
  "
  (click)="scrollToTop()"
  title="{{ 'APP.COMMENTS.SCROLL_TO_TOP' | translate }}"
>
  <mat-icon>arrow_upward</mat-icon>
</button>
<section id="trackchanges"></section>
<section id="comments"></section>
<section id="releasenotes"></section>
